import { shallowMount } from "@vue/test-utils";
import ConsultaEmprendedores from "@/views/ConsultaEmprendedores";

describe("ConsultaEmprendedores component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ConsultaEmprendedores, {
      computed: {
        responsiveTerms() {
          return true;
        }
      }
    });
  });

  it("Renders del component ConsultaEmprendedores", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
